<template>
    <div
        ref="zalo"
        class="zalo-chat-widget"
        style="bottom: 24px; right: 16px"
        :style="hidden ? 'display: none' : ''"
        data-autopopup="30"
        data-width="500"
        data-height="500"
        data-oaid="4026392812570217406"
        data-welcome-message="Kính chào quý khách, quý khách hãy liên lạc với đội ngũ hỗ trợ khi cần nhé!!"
    >
        <div
            v-if="!hidden"
            class="hidden-zalo"
            title="Ẩn chat zalo"
            @click="hidden = !hidden"
        ></div>
    </div>

    <div v-if="hidden" class="show-zalo" title="Hiện chat zalo" @click="hidden = !hidden">
        {{ `Z\nA\nL\nO` }}
    </div>

    <!-- <div class="zalo-btn" style="position: fixed; right: 16px; bottom: 24px">
        <img
            src="https://page.widget.zalo.me/static/images/2.0/Logo.svg"
            alt=""
            style="
                border-radius: 50%;
                box-shadow: 0 5px 9px #6a6a6a;
                background: #fff;
            "
            @click="openChatBox()"
        />
    </div> -->
</template>

<script>
export default {
    data() {
        return {
            hidden: true,
        };
    },
    mounted() {
        // return;
        var zalo = this.$refs.zalo;
        // console.log("ZaloSocialSDK", this.$refs.zalo, window.ZaloSocialSDK);
        if (!window.ZaloSocialSDK) {
            ((d) =>
                ((p) => (e) => (s) =>
                    p.insertAdjacentElement("beforeend", ((e.src = s), e)))(d.body)(
                    d.createElement("script")
                )(`https://sp.zalo.me/plugins/sdk.js`))(document);
        } else {
            window.ZaloSocialSDK.reload();
        }
        setTimeout(function () {
            zalo.style.bottom = "24px";
            zalo.style.right = "16px";

            setTimeout(function () {
                if (window.ZaloSocialSDK) {
                    // window.ZaloSocialSDK.openChatWidget();
                    // setTimeout(function () {
                    //     if (window.ZaloSocialSDK) {
                    //         window.ZaloSocialSDK.closeChatWidget();
                    //         zalo.style.bottom = 0;
                    //         zalo.style.left = 0;
                    //     }
                    // }, 5000);
                }
            }, 1000);
        }, 1500);
    },
};
</script>

<style scoped>
.hidden-zalo {
    width: 24px;
    height: 8px;
    background: gray;
    position: absolute;
    z-index: 2;
    top: 8px;
    right: 0;
    cursor: pointer;
    border-radius: 4px;
}
.show-zalo {
    color: #fff;
    background-color: #0068ff;
    white-space: break-spaces;
    position: fixed;
    z-index: 2;
    bottom: 56px;
    padding: 4px 6px;
    text-align: center;
    right: 0;
    cursor: pointer;
    border-radius: 8px 0 0 8px;
    font-weight: 500;
}
</style>
